import {Typography, useTheme, css} from '@mui/material';
import {DlMuiPopper, GetStylesFunction, mixins, useMuiAnchor, DlMuiDynamicIcon} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';
import {EntityLink} from 'src/js/containers/file/components/EntityLink';

import {HaidiSchema} from '../../types';
import {useFormatters} from '../light';

type OwnProps = ICellRendererParams;

type Props = OwnProps;

export const HaidiEncounterLinkFormatter: React.FC<Props> = (props) => {
  const {value, data} = props;
  const url = `/encounter/${data.encounterId}`;

  const label = value;
  const hasTooltip = !!label;

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);

  const theme = useTheme();
  const styles = getStyles({theme});
  const {tEnum} = useFormatters();

  const encounterType = data?.encounterType as HaidiSchema.components['schemas']['EncounterTypeEnum'] | undefined;
  let icon = {
    iconName: 'haidiBedIcon',
    viewBox: '0 0 12 10',
    iconTitle: tEnum('EncounterTypeEnum', encounterType ?? ''),
  };
  if (encounterType === 'OUTPATIENT') {
    icon = {
      ...icon,
      iconName: 'haidiStethoscopeIcon',
      viewBox: '0 0 12 12',
    };
  }
  return (
    <Typography css={styles.linkWrapper} variant={'textButton'}>
      <div css={styles.dlLinkFormatter}>
        <EntityLink route={url} suppressPadding>
          <div css={styles.linkContent}>
            <DlMuiDynamicIcon
              iconName={icon.iconName}
              iconTitle={icon.iconTitle}
              useFixedViewBox={icon.viewBox}
              inputCss={styles.iconWrapper}
              svgIconInputCss={styles.icon}
              noButtonStyles
            />
            <span css={styles.span} onMouseEnter={mouseEventEnter} onMouseLeave={mouseEventLeave}>
              {label}
            </span>
          </div>
          <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
            <Typography variant={'popper'}>{label}</Typography>
          </DlMuiPopper>
        </EntityLink>
      </div>
    </Typography>
  );
};

HaidiEncounterLinkFormatter.displayName = 'HaidiEncounterLinkFormatter';

const getStyles: GetStylesFunction = (options) => ({
  linkWrapper: css`
    line-height: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  dlLinkFormatter: css`
    ${mixins.dlTextOverflowEllipses};
    min-width: 0;
  `,
  linkContent: css`
    display: flex;
    gap: 10px;
  `,
  iconWrapper: css`
    color: inherit;
    background: none !important;
    padding: 0 !important;
    margin-bottom: 1px;
    cursor: pointer !important;
  `,
  icon: css`
    width: 12px;
    height: 12px;
    cursor: pointer !important;
  `,
  span: css`
    ${mixins.dlTextOverflowEllipses};
    text-decoration: underline;
    padding: ${options?.theme?.spacing(1, 0)};
  `,
});
